import React from 'react'
import { Block, Button, H3, P } from '@mote/ui'

export const LoginError = ({ error }) => {
  return (
    <Block align="flex-start" gap={20}>
      <H3>Aw snap. We haven't been able to sign you in.</H3>

      <P>
        Please try clicking below to refresh your browser. <br></br>If that
        doesn't work, please click 'Login' above, and then try signing in with
        another Google account (if you have one).
      </P>
      <P>
        If you've tried that, and still see this message, the issue may be
        caused by a problem with the Google permissions that are stored on your
        machine. The easiest way to fix this is to simply select 'Clear browsing
        data' from the Chrome menu in your browser, then ensure 'Cookies and
        other site data' is selected, and then ensure that you're clearing at
        least the last 24 hours. If you can't then login, please email
        support@mote.com and we'll do our best to get you up and running.
      </P>
      <Button
        onClick={() => {
          window.location.href = `${window.location.protocol}//${window.location.host}/login?force=1`
        }}
        text="Click to refresh"
      />

      {error && (
        <code
          style={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-all',
            fontSize: 14
          }}
        >
          {JSON.stringify(error, null, 2)}
        </code>
      )}
    </Block>
  )
}
